import { GaussianBlurBackgroundProcessor, GaussianBlurBackgroundProcessorOptions } from './processors/background/GaussianBlurBackgroundProcessor';
import { SolidColorBackgroundProcessor, SolidColorBackgroundProcessorOptions } from './processors/background/SolidColorBackgroundProcessor';
import { VirtualBackgroundProcessor, VirtualBackgroundProcessorOptions } from './processors/background/VirtualBackgroundProcessor';
import { ImageFit } from './types';
import { isSupported } from './utils/support';
const version = '1.0.1'

if (typeof window !== 'undefined') {
  window.Twilio = window.Twilio || {};
  /*@ts-ignore*/
  window.Twilio.VideoProcessors = {
      /*@ts-ignore*/
    ...window.Twilio.VideoProcessors,
    GaussianBlurBackgroundProcessor,
    SolidColorBackgroundProcessor,
    ImageFit,
    isSupported,
    version,
    VirtualBackgroundProcessor,
  };
}

export {
  GaussianBlurBackgroundProcessor,
  SolidColorBackgroundProcessor,
  ImageFit,
  isSupported,
  version,
  VirtualBackgroundProcessor
};

export type {
  GaussianBlurBackgroundProcessorOptions,
  SolidColorBackgroundProcessorOptions,
  VirtualBackgroundProcessorOptions
}
